import useApiMutation from 'shared/hooks/use-api-mutation';
import {OrderProps, OrderStatus} from '../types';
import useUpdateOrder from '../util/use-update-orders';

const useArriveOrder = (orderId: string) => {
  const updateOrder = useUpdateOrder();

  const onSuccess = (data: OrderProps) =>
    updateOrder(data, OrderStatus.arrival);

  return useApiMutation({
    url: `/orders/${orderId}/arrival`,
    method: 'PATCH',
    errorTitle: 'Erro ao cancelar pedido',
    successTitle: 'Alteração de status do pedido',
    successMessage: 'Pedido na porta do cliente!',
    onSuccess,
  });
};

export default useArriveOrder;
